


// product details

export const remove_from_cart = "remove_from_cart"
export const update_cart = "update_cart"
export const fetch_cart = "fetch_cart"
export const set_cart = "set_cart"
export const add_to_cart = "add_to_cart"
export const update_cart_display_status = "update_cart_display_status"
export const loading_cart = "loading_cart"
export const recalculate_cart_total = "recalculate_cart_total"
export const request_cart_total = "request_cart_total"
export const HasError = "HasError"



export const GetBrandsList = "GetBrandsList";
export const BrandsLoaded = "BrandsLoaded";


export const GetProductListPaging = "GetProductListPaging";
export const GetProductListPagingLoaded = "GetProductListPagingLoaded";



// checkout
export const SET_CHECKOUT_NOTE = "SET_CHECKOUT_NOTE";


// product details page
export const reserve_item = "reserve_item";
